/**
 * @jsxRuntime classic
 * @jsx jsx
 *
 * ImageWrapper component using @atlaskit/css
 */
import React from 'react';

import { cssMap, jsx } from '@atlaskit/css';

import { CALCULATE_SCALED_COVER_IMAGE_HEIGHT_FOR_EDIT_PAGE } from '../pageCoverPictureConstants.ts';

const COVER_IMAGE_FIXED_HEIGHT = 147;

const imageWrapperStyles = cssMap({
	base: {
		width: '100%',
		objectFit: 'cover',
		position: 'absolute',
		'&:hover': {
			opacity: 1,
		},
		aspectRatio: '38 / 7',
	},
	fixed: { height: `${COVER_IMAGE_FIXED_HEIGHT}px` },
	scaled: {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- CSS calc expression for responsive height
		height: CALCULATE_SCALED_COVER_IMAGE_HEIGHT_FOR_EDIT_PAGE as `${number}px`,
	},
});

type ImageWrapperCssProps = {
	coverPicturePosition?: number | null;
	isFixedWidthImageOption?: boolean;
} & Omit<React.ComponentProps<'img'>, 'css'>;

export const ImageWrapperCss = ({
	coverPicturePosition,
	isFixedWidthImageOption,
	style,
	...imgProps
}: ImageWrapperCssProps) => {
	'use no memo'; // Exclude from React compiler - breaks unit tests when component uses compiled CSS
	return (
		<img
			{...imgProps}
			// need this empty alt tag for decorative images
			alt=""
			css={[
				imageWrapperStyles.base,
				imageWrapperStyles[isFixedWidthImageOption ? 'fixed' : 'scaled'],
			]}
			// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- objectPosition depends on dynamic runtime value
			style={{ objectPosition: `center ${coverPicturePosition}%`, ...style }}
		/>
	);
};
